(function () {
  'use strict';
  if (window.FannifenSkTierCart) return;
  function state(subtotal) {
    var tiers = [[11500, 600], [18500, 1200], [28000, 2000]];
    var tier = tiers.find(function (t) { return subtotal < t[0]; }) || tiers[2];
    return {gap: Math.max(0, tier[0] - subtotal), saving: tier[1], top: subtotal >= 28000, progress: Math.min(100, subtotal / tier[0] * 100)};
  }
  function update(cart) {
    if (!cart || !/^(www\.)?fannifen\.(sk|de)$/.test(window.location.hostname) || cart.currency !== 'EUR') return false;
    var bars = document.querySelectorAll('[data-fannifen-sk-tier-cart]');
    var subtotal = Number(cart.items_subtotal_price);
    if (!bars.length || !Number.isFinite(subtotal) || subtotal < 0) return false;
    var tier = state(subtotal);
    bars.forEach(function (bar) {
      var locale = bar.dataset.locale || 'en';
      var money = new Intl.NumberFormat(locale, {style: 'currency', currency: 'EUR'});
      var text = tier.top ? bar.dataset.top : bar.dataset.next;
      var message = bar.querySelector('[data-sk-tier-message]');
      message.replaceChildren();
      text.split(/(\[gap\]|\[saving\])/).forEach(function (part) {
        if (part === '[gap]' || part === '[saving]') {
          var number = document.createElement('span');
          number.style.color = '#c62828';
          number.textContent = money.format((part === '[gap]' ? tier.gap : tier.saving) / 100);
          message.appendChild(number);
        } else message.appendChild(document.createTextNode(part));
      });
      bar.querySelector('[data-sk-tier-progress]').style.width = tier.progress + '%';
      bar.dataset.subtotal = String(subtotal);
    });
    return true;
  }
  window.FannifenSkTierCart = {update: update};
  var initial = document.querySelector('[data-fannifen-sk-tier-cart]');
  if (initial) update({currency: initial.dataset.currency, items_subtotal_price: Number(initial.dataset.subtotal)});
}());
